module.exports = __webpack_public_path__ + "media/src/images/logo-363ba3bcce7dc50a9b3a3802efa6e07b.png";